import { __assign } from "tslib";
import { ColumnActionsMode, css, GroupHeader, ScrollablePane } from '@fluentui/react';
import React from 'react';
import { CoherenceDataGridColumnWidth } from './CoherenceDataGrid.styles';
import { CoherenceCheck, DataGridColumn } from './Components';
var defaultOnRender = function (item, _index, column, theme) {
    return React.createElement(DataGridColumn, { data: item, column: column, theme: theme });
};
export var setColumnSortProps = function (column, reverseSort, currentSortKey) {
    if (currentSortKey === column.key) {
        column.isSorted = true;
        column.isSortedDescending = reverseSort;
    }
    else {
        column.isSorted = false;
    }
};
export var setColumnWidthBoundaries = function (column) {
    var maxWidth = column.maxWidth, minColumnWidth = column.minColumnWidth;
    column.minWidth = minColumnWidth || CoherenceDataGridColumnWidth.min;
    column.maxWidth = maxWidth || CoherenceDataGridColumnWidth.max;
};
export var setSortableColumn = function (column, isSortable, onColumnClick) {
    if (isSortable) {
        column.onColumnClick = onColumnClick;
    }
    else {
        column.columnActionsMode = ColumnActionsMode.disabled;
    }
};
export var setRightAlignment = function (column, classNames) {
    var type = column.type;
    var isRightAligned = type === 'dayjs' || type === 'number' || type === 'currency' || type === 'date';
    if (column.invertAlignment) {
        isRightAligned = !isRightAligned;
    }
    if (isRightAligned) {
        column.className = css(classNames.cellRightAligned, column.className);
        column.headerClassName = css(classNames.headerRightAligned, column.headerClassName);
    }
};
export var setCenterAlignment = function (column, classNames) {
    var type = column.type;
    if (type === 'actions') {
        column.className = css(classNames.cellCenterAligned, column.className);
        column.headerClassName = css(classNames.headerCenterAligned, column.headerClassName);
    }
};
export var getColumnConfig = function (props, isSortable, listConfig, classNames, onColumnClick, theme) {
    return listConfig.map(function (columnSpecified) {
        var currentSortKey = props.currentSortKey, reverseSort = props.reverseSort;
        var columnToBuild = Object.assign({}, columnSpecified);
        var defaultRenderCall = function (item, index, column) {
            return defaultOnRender(item, index, column, theme);
        };
        setSortableColumn(columnToBuild, isSortable, onColumnClick);
        columnToBuild.onRender = columnSpecified.onRender || defaultRenderCall;
        setRightAlignment(columnToBuild, classNames);
        setCenterAlignment(columnToBuild, classNames);
        setColumnSortProps(columnToBuild, reverseSort, currentSortKey);
        setColumnWidthBoundaries(columnToBuild);
        columnToBuild.isMultiline =
            columnSpecified.type === 'link' || columnSpecified.type === 'secondaryLink' ? false : columnSpecified.isMultiline;
        return columnToBuild;
    });
};
export var onRenderCheckbox = function (checkboxProps) {
    var renderer = function (props) {
        return React.createElement(CoherenceCheck, __assign({}, props));
    };
    return React.createElement("div", null, renderer(__assign({}, checkboxProps)));
};
var onRenderGroupHeaderCheckbox = function (props) { return (React.createElement(CoherenceCheck, __assign({}, props, { styles: { circle: { marginLeft: '-8px' }, check: { marginLeft: '-8px' } } }))); };
export var onRenderGroupHeader = function (props) { return (React.createElement(GroupHeader, __assign({ onRenderGroupHeaderCheckbox: onRenderGroupHeaderCheckbox }, props, { styles: { check: { opacity: 1 } } }))); };
export var getRow = function (rowProps, defaultRender, onRenderRow, rowStyles) {
    var renderer = onRenderRow || defaultRender;
    return React.createElement("div", null, renderer(__assign(__assign({}, rowProps), { styles: rowStyles }), defaultRender));
};
export var getDetailsHeader = function (detailsHeaderProps, defaultRender, onRenderDetailsHeader, headerStyles) {
    var renderer = onRenderDetailsHeader || defaultRender;
    return React.createElement(React.Fragment, null, renderer(__assign(__assign({}, detailsHeaderProps), { styles: headerStyles }), defaultRender));
};
export var fetchKey = function (item, getKey, _index) {
    return (getKey === null || getKey === void 0 ? void 0 : getKey(item, _index)) || item.key;
};
export var DataGridWrapper = function (_a) {
    var isScrollable = _a.isScrollable, scrollableStyles = _a.scrollableStyles, children = _a.children;
    return isScrollable ? (React.createElement("div", { role: "presentation", className: scrollableStyles },
        React.createElement(ScrollablePane, null, children))) : (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=CoherenceDataGrid.utilities.js.map